import React, {Component} from 'react';
import Swiper from 'react-id-swiper/lib/custom';

import ProjectCard from '../Cards/ProjectCard';
import './styles/ProjectsCarousel.css';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Link} from "react-router-dom";
import Image from "../Image";

class ProjectsCarousel extends Component {
    render() {
        const params = {
            spaceBetween: 16,
            direction: 'horizontal',
            slidesPerView: 2.5,
            keyboard: {
                enabled: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            renderPrevButton: () => <div className="swiper-button-prev"><FontAwesomeIcon className={'icon'}
                                                                                         icon={'arrow-left'}/></div>,
            renderNextButton: () => <div className="swiper-button-next"><FontAwesomeIcon className={'icon'}
                                                                                         icon={'arrow-right'}/></div>,
            breakpoints: {
                // when window width is <= 512px
                512: {
                    slidesPerView: 1.01,
                    // centeredSlides: true,
                },
                // when window width is <= 812px
                812: {
                    slidesPerView: 1.4,
                    centeredSlides: true,
                },
                // when window width is <= 1200px
                1200: {
                    slidesPerView: 2.2,
                }
            },

        };

        if (this.props.projectSlde) {
            return (
                <Swiper {...params}>
                    {this.props.projects.map(function (project, i) {
                        return (
                            <div className="slide" key={i}>
                                <ProjectCard project={project}/>
                            </div>
                        )
                    })}
                <div className="slide">
                    <Link className={'card-project'} to={
                        {
                            pathname: `/projects`,
                            state: {modal: false}
                        }
                    }>
                        <Image aspectRatio={'4:3'} cover shadow/>
                        <div className={'last--slide'}>
                            <FontAwesomeIcon className={'icon icon--carousel'} icon={'plus-circle'}/>
                            <div className={'link'}>View more</div>
                        </div>
                    </Link>
                </div>
            </Swiper>
            );
        }
        else {
            return (
                <Swiper {...params}>
                    {this.props.projects.map(function (project, i) {
                        return (
                            <div className="slide" key={i}>
                                <ProjectCard project={project}/>
                            </div>
                        )
                    })}
                </Swiper>
            )
        }
    }
}

export default ProjectsCarousel;